<template>
  <notification-item @timeout="onClose">
    <template v-slot:text>
      <span>{{ chart.chartData.mapName }}</span>
      {{ $t('removedFromBase') }}
    </template>
    <template v-slot:button>
      <button @click="onCancel">
        {{ $t('login.cancel') }}
      </button>
    </template>
  </notification-item>
</template>

<script>
import { mapActions } from 'vuex';

import { ChartTypeTranslation } from '@/types';
import { NotificationItem } from '@/elements/components/notification';

export default {
  name: 'DeleteNotificationItem',
  components: {
    NotificationItem,
  },
  props: {
    chart: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ChartTypeTranslation,
    };
  },
  methods: {
    ...mapActions('ChartModule', ['totalDeleteHistoryItem', 'revertDeleteHistoryItem']),
    onCancel() {
      this.revertDeleteHistoryItem(this.chart);
    },
    onClose() {
      this.totalDeleteHistoryItem(this.chart);
    },
  },
};
</script>

<style lang="sass" scoped>
span
  display: inline-block
  opacity: 1
</style>
